import { Box, Button } from "@mui/material";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import WarehouseOutlinedIcon from "@mui/icons-material/WarehouseOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import * as React from "react";
import B2BCouriers from "./B2bCouriers";
import B2CCouriers from "./B2cCouriers";
import CourierConfig from "./courierConfig";
import B2bCourierRateCard from "./B2BCourierRateCard";
import useTabParam from "../../hooks/useTabParam";
import BulkAttributeUploadDialog from "./BulkAttributeUploadDialog";

// Full-width segmented control — equal-width tabs spanning the page, iOS-style lifted active segment.
// Each tab carries its own accent (main colour + light tint) for a subtle per-tab gradient when active.
const TABS = [
  { value: "1", label: "B2C Couriers", icon: <LocalShippingOutlinedIcon sx={{ fontSize: 18 }} />, main: "#1565c0", tint: "#e8f1fc" },
  { value: "2", label: "B2B Couriers", icon: <WarehouseOutlinedIcon sx={{ fontSize: 18 }} />, main: "#0f766e", tint: "#e4f3f1" },
  { value: "3", label: "Courier Config B2C", icon: <TuneOutlinedIcon sx={{ fontSize: 18 }} />, main: "#6d28d9", tint: "#f1ecfd" },
  { value: "4", label: "B2B Courier Rate Card", icon: <ReceiptLongOutlinedIcon sx={{ fontSize: 18 }} />, main: "#b45309", tint: "#fdf2e5" },
];

function CourierTabs() {
  const [value, setValue] = useTabParam("1");
  const [bulkOpen, setBulkOpen] = React.useState(false);

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1.5 }}>
        <Button
          size="small"
          variant="outlined"
          startIcon={<UploadFileOutlinedIcon />}
          onClick={() => setBulkOpen(true)}
          sx={{ whiteSpace: "nowrap", textTransform: "none", fontWeight: 600 }}
        >
          Bulk Attribute Upload
        </Button>
      </Box>

      <Box
        sx={{
          display: "flex",
          width: "100%",
          gap: "5px",
          p: "5px",
          mb: 2,
          bgcolor: "#eef1f5",
          borderRadius: "12px",
        }}
      >
        {TABS.map((t) => {
          const isActive = value === t.value;
          return (
            <Box
              key={t.value}
              onClick={() => setValue(t.value)}
              sx={{
                flex: "1 1 0",
                minWidth: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                py: 1.1,
                px: 1,
                borderRadius: "9px",
                cursor: "pointer",
                fontFamily: "Poppins, sans-serif",
                fontSize: "13px",
                fontWeight: isActive ? 700 : 500,
                whiteSpace: "nowrap",
                transition: "all 0.18s ease",
                background: isActive ? `linear-gradient(135deg, #ffffff 0%, ${t.tint} 100%)` : "transparent",
                color: isActive ? t.main : "#64748b",
                boxShadow: isActive ? `0 1px 3px rgba(15,23,42,0.12), inset 0 0 0 1px ${t.main}26` : "none",
                "&:hover": isActive
                  ? {}
                  : { color: t.main, bgcolor: "rgba(255,255,255,0.55)" },
              }}
            >
              {t.icon}
              <Box component="span" sx={{ overflow: "hidden", textOverflow: "ellipsis" }}>{t.label}</Box>
            </Box>
          );
        })}
      </Box>

      <BulkAttributeUploadDialog open={bulkOpen} onClose={() => setBulkOpen(false)} />

      {value === "1" && <B2CCouriers />}
      {value === "2" && <B2BCouriers />}
      {value === "3" && <CourierConfig />}
      {value === "4" && <B2bCourierRateCard />}
    </>
  );
}

export default CourierTabs;
